import React, { Suspense, useContext, useEffect, useState } from "react";
import "./pms.css";
import { TostMsg } from "../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import {
  getAllCycles,
  GetEmployeeGoals,
  getSelfAppraisals,
  GetSkipLevelAppraisals,
  GetTeamAppraisals,
  SendAppraisalNotification,
} from "./PMSService";

const AssessmentEmployeeCycles = () => {
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [isLoading, setIsLoading] = useState(false);
  const [showAckModal, setShowAckModal] = useState(false);
 let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const history = useHistory();
  const toster = useContext(TostMsg);
const [managerReview, setManagerReview] = useState(false);
  const [appraisals, setAppraisals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showFeedback, setShowFeedback] = useState({});
  const [kraList, setKraList] = useState([]);
  const [kraLoading, setKraLoading] = useState(false);
  const [selectedCycleId, setSelectedCycleId] = useState("");
  const [teamAppraisals, setTeamAppraisals] = useState([]);
  const [skipLevelAppraisals, setSkipLevelAppraisals] = useState([]);
  const [loadingTeam, setLoadingTeam] = useState(false);
  const [loadingSkipLevel, setLoadingSkipLevel] = useState(false);
  const [loadingCycles, setLoadingCycles] = useState(false);
  const [selectedAppraisalGuid, setSelectedAppraisalGuid] = useState("");
  const [showRemindnoti, setShowRemindnoti] = useState(false);
  const [selectedReminderItem, setSelectedReminderItem] = useState(null);
  const [sendingReminder, setSendingReminder] = useState(false);
  const [reminderMessage, setReminderMessage] = useState("");
  const [allCycles, setAllCycles] = useState([]);

  const fetchAppraisals = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await getSelfAppraisals();

      if (response?.success === false) {
        setError(response?.message || "Unable to load appraisals.");
        return;
      }

      const data = response?.Data || response?.result || [];

      if (!Array.isArray(data)) {
        setError("Invalid appraisal data received.");
        setAppraisals([]);
        return;
      }

      setAppraisals(data);
      // getAppraisalLetters();

      // if (data?.length > 0) {
      //   const defaultCycle =
      //     data.find(
      //       (item) => item?.IsActive === true || item?.Active === true,
      //     ) || data[0];

      //   const cycleId = defaultCycle?.CycleId;

      //   setSelectedCycleId(cycleId);

      //   const appraisalGuid = defaultCycle?.GUID || "";

      //   setSelectedAppraisalGuid(appraisalGuid);
      // }
    } catch (err) {
      console.error("getSelfAppraisals error:", err);
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "An unexpected error occurred.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppraisals();
    fetchEmployeeGoals();
    fetchAllCycles();
    userPermissions.map((UserPermission) => {
      if (
        UserPermission.PermissionName == "PMS.Review" &&
        UserPermission.IsGranted == true
      ) {
        setManagerReview(true);
      }
    })
  }, []);

  useEffect(() => {
    if (!selectedCycleId) return;

    fetchTeamAppraisals(selectedCycleId);
    fetchSkipLevelAppraisals(selectedCycleId);
  }, [selectedCycleId]);


  const fetchAllCycles = async () => {
    try{
      const response = await getAllCycles();

      const data = response?.Data || [];

      if(response?.StatusCode === 2000){
        setAllCycles(data);

       if (data?.length > 0) {
        const defaultCycle =
          data[0];

        const cycleId = defaultCycle?.Id;

        setSelectedCycleId(cycleId);

        const appraisalGuid = defaultCycle?.Guid || "";

        setSelectedAppraisalGuid(appraisalGuid);
       }
      }
    }
    catch(error){

    }
  }


  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const formatPeriod = (from, to) => {
    if (!from || !to) return "-";

    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (Number.isNaN(fromDate.getTime()) || Number.isNaN(toDate.getTime())) {
      return "-";
    }

    return `${fromDate.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    })} – ${toDate.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    })}`;
  };

  const getStatus = (item) => {
    if (item?.CurrentStageName === "Closed") {
      return "Completed";
    }

    if (item?.CurrentStageName?.toLowerCase() === "self assessment") {
      return "Pending";
    }

    if (
      item?.CurrentStageName === "Manager Review" ||
      item?.CurrentStageName === "Skip-Level Review" ||
      item?.CurrentStageName?.toLowerCase() === "Normalization"
    ) {
      return "Self Assessment";
    }

    return item?.CurrentStageName || "Pending";
  };

  const getRatingClass = (rating) => {
    if (!rating) return "badge-adequate";

    const value = Number(rating);

    if (value >= 4) {
      return "badge-vital";
    }

    return "badge-adequate";
  };

  const getRatingText = (item) => {
    if (!item?.score && !item?.rating) {
      return "";
    }

    const score = item?.score ?? item?.rating;
    const rating = item?.ratingName ?? item?.ratingText ?? "";

    return rating ? `${score} · ${rating}` : `${score}`;
  };

  const toggleFeedback = (cycleId) => {
    setShowFeedback((prev) => ({
      ...prev,
      [cycleId]: !prev[cycleId],
    }));
  };

  const handleSelfAssessment = (item) => {
    if (!item?.CycleId) {
      console.error("Cycle ID is missing.");
      return;
    }

    history.push(`/Assessment/SelfAssessment/${item?.GUID}`, {
      state: {
        appraisal: item,
      },
    });
  };

  const handleEmployeeAppraisalView = (item) => {
    // if (!item?.CycleId) {
    //   console.error("Cycle ID is missing.");
    //   return;
    // }

    history.push(`/Assessment/Employee/Dashboard/View/${item?.GUID}`, {
      state: {
        appraisal: item,
      },
    });
  };

  const openAckModal = (item) => {
    if (!item?.CycleId) {
      console.error("Cycle ID is missing.");
      return;
    }

    // Your acknowledgement modal logic
    console.log("Acknowledge appraisal:", item);
  };

  const handleGoBack = () => {
    history.goBack();
  };

  const handleSkipLevelReview = () => {
    if (!selectedAppraisalGuid) {
      console.error("Appraisal GUID not found for selected cycle");
      return;
    }

    history.push(`/Assessment/Skiplevel/list`);
  };

  const handleCycleDetail = () => {
    history.push("/Assessment/Cycle/Details");
  };

  const handleGoals = () => {
    history.push("/Assessment/goals");
  };

  const closeAckModal = () => {
    setShowAckModal(false);
  };

  const sendRemind = (item) => {
    if (!item?.AppraisalId) {
      console.error("AppraisalId is missing", item);

      toster?.setToast?.({
        type: "error",
        message: "Appraisal ID is missing.",
      });

      return;
    }

    setSelectedReminderItem(item);

    setReminderMessage(
      `Please complete your self-assessment for ${item?.CycleTitle || "the current appraisal"}.`,
    );

    setShowRemindnoti(true);
  };

  const handleSendReminder = async () => {
    const appraisalId = selectedReminderItem?.AppraisalId;

    if (!appraisalId) {
      console.error("AppraisalId is missing");
      return;
    }

    try {
      setSendingReminder(true);

      const payload = {
        NotificationType: "SelfReminder",
        CustomMessage:
          reminderMessage?.trim() ||
          `Please complete your self-assessment for ${
            selectedReminderItem?.CycleTitle || "the current appraisal"
          }.`,
      };

      console.log("Sending appraisal reminder:", {
        appraisalId,
        payload,
      });

      const response = await SendAppraisalNotification(appraisalId, payload);

      if(response?.StatusCode === 2000){
        toster.current.success("Notification sent successfully");
      }

      if (response?.success === false) {
        toster.current.error(response?.Message || "Unable to send reminder.");
      }

      setShowRemindnoti(false);
      setSelectedReminderItem(null);
      setReminderMessage("");
    } catch (error) {
      console.error("Send appraisal reminder error:", error);

      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to send reminder.";

      toster?.setToast?.({
        type: "error",
        message,
      });
    } finally {
      setSendingReminder(false);
    }
  };

  const closeReminderModal = () => {
    if (sendingReminder) return;

    setShowRemindnoti(false);
    setSelectedReminderItem(null);
    setReminderMessage("");
  };

  const fetchEmployeeGoals = async () => {
    if (!userDetails?.Id) return;

    setKraLoading(true);

    try {
      const response = await GetEmployeeGoals({ empId: userDetails?.Id });

      const data = response?.Data?.Kras || [];

      setKraList(data);
    } catch (error) {
      console.error("Error fetching employee goals:", error);
      setKraList([]);
    } finally {
      setKraLoading(false);
    }
  };

  const fetchTeamAppraisals = async (cycleId) => {
    const params = {
      CycleId: cycleId,
      StageFilter: "",
      Search: "",
      PageNumber: 1,
      PageSize: 3,
    };
    try {
      const response = await GetTeamAppraisals(params);

      const data = response?.Data?.Items || [];

      setTeamAppraisals(data);
      setTeamAppraisalsCount(response?.Data?.Summary?.Total);
    } catch (error) {
      console.error("Error fetching employee goals:", error);
      setTeamAppraisals([]);
    } finally {
    }
  };

  const [skipLevelAppraisalsCount, setSkipLevelAppraisalsCount] = useState(0);
  const [teamAppraisalsCount, setTeamAppraisalsCount] = useState(0);
  const fetchSkipLevelAppraisals = async (cycleId) => {
    const params = {
      CycleId: cycleId,
      StageFilter: "",
      Search: "",
      PageNumber: 1,
      PageSize: 3,
    };
    try {
      const response = await GetSkipLevelAppraisals(params);

      const data = response?.Data?.Items || [];

      setSkipLevelAppraisals(data);
      setSkipLevelAppraisalsCount(response?.Data?.Summary?.Total);
    } catch (error) {
      console.error("Error fetching employee goals:", error);
      setSkipLevelAppraisals([]);
    } finally {
      setKraLoading(false);
    }
  };

  const handleCycleChange = (e) => {
    const cycleId = e.target.value;

    setSelectedCycleId(cycleId);

    const selectedCycle = allCycles.find(
      (cycle) =>
        String(cycle?.Id ?? cycle?.Id ?? cycle?.OAPId) === String(cycleId),
    );

    const appraisalGuid = selectedCycle?.Guid || "";

    setSelectedAppraisalGuid(appraisalGuid);
  };

  const handleTeamReview = (item) => {
    console.log("Team review:", item);

    const guid = selectedAppraisalGuid;

    if (!guid) {
      console.error("Assessment GUID not found", item);
      return;
    }

    history.push(`/Assessment/team-level/list`);
  };

  const teamManagersReview = (item, type) => {
    const guid = item?.AppraisalGUID;

    if (type === "review") {
      history.push(`/Assessment/Review/${guid}`);
    } else {
      history.push(`/Assessment/View/${guid}`);
    }
  };

  const handleTeamManagersView = (item) => {
    const guid = item?.AppraisalGUID;

    history.push(`/Assessment/view/${guid}`);
  };

  const handleSkipLevelCycleReviews = (item) => {
    console.log("Skip level review:", item);

    const guid = item?.AppraisalGUID;

    if (!guid) {
      console.error("Assessment GUID not found", item);
      return;
    }

    history.push(`/Assessment/Skiplevel/Review/${guid}`);
  };

  const handleSkipLevelCycleViews = (item) => {
    const guid = item?.AppraisalGUID;

    history.push(`/Assessment/Skiplevel/View/${guid}`);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">
                  Employee Assessment Dashboard
                </h2>
              </div>
              <div className="rightside-tabs">
                <button
                  type="button"
                  className="btn btn-outline btn-sm btn-gray float-right"
                 
                  onClick={handleGoBack}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    fill="currentColor"
                    className="bi bi-arrow-left"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                    />
                  </svg>
                  Back
                </button>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="section-emp-cycle">
              <div className="left-emp-cycle">
                <div className="mb-3">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <div className="og-hub-title">
                      <i
                        className="fa fa-clipboard-list"
                        style={{ color: "#EC4119" }}
                      />{" "}
                      My Appraisals
                    </div>
                  </div>

                  {appraisals.length === 0 ? (
                    <div className="og-cycle-card text-center">No appraisals found.</div>
                  ) : (
                    appraisals.map((item) => {
                      const isPending =
                        item?.CurrentStageName === "Self Assessment";

                      const isInProgress =
                        item?.CurrentStageName === "Manager Review" ||
                        item?.CurrentStageName === "Skip-Level Review" ||
                        item?.CurrentStageName === "Normalization";

                      const isCompleted = item?.CurrentStageName === "Closed";

                      return (
                        <div
                          key={item?.CycleId}
                          className="og-cycle-card"
                          style={{
                            marginBottom: 8,
                            cursor: "pointer",
                            opacity: isCompleted ? 0.9 : 1,
                          }}
                          onClick={() =>
                            isPending 
                              ? handleSelfAssessment(item)
                              : handleEmployeeAppraisalView(item)
                          }
                        >
                          <div className="og-cycle-card-header">
                            <div>
                              <div className="og-cycle-name">
                                {item?.CycleTitle}
                              </div>

                              <div className="og-cycle-period">
                                Review Period:{" "}
                                {formatPeriod(
                                  item?.ReviewPeriodFrom,
                                  item?.ReviewPeriodTo,
                                )}
                              </div>
                            </div>

                            {isPending ? (
                              <span className="badge-og badge-self">
                                {getStatus(item)}
                              </span>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {getRatingText(item) && (
                                  <span
                                    className={`badge-og ${getRatingClass(
                                      item?.score ?? item?.rating,
                                    )}`}
                                  >
                                    {getRatingText(item)}
                                  </span>
                                )}

                                <span className="badge-og badge-completed">
                                  {isInProgress ? "In reviewed" : "Completed"}
                                </span>
                              </div>
                            )}
                          </div>

                          {isPending ? (
                            <>
                              <div className="og-timeline">
                                <div className="og-tl-item">
                                  <div className="og-tl-label">
                                    <i
                                      className="fa fa-play-circle"
                                      style={{ color: "#EC4119" }}
                                    />{" "}
                                    Started
                                  </div>

                                  <div className="og-tl-date">
                                    {formatDate(item?.CycleStartDate)}
                                  </div>
                                </div>

                                <div className="og-tl-item">
                                  <div className="og-tl-label">
                                    <i
                                      className="fa fa-pen-to-square"
                                      style={{ color: "#d97706" }}
                                    />{" "}
                                    Self By
                                  </div>

                                  <div
                                    className="og-tl-date"
                                    style={{ color: "#d97706" }}
                                  >
                                    {formatDate(item?.SelfAssessmentDeadline)}
                                  </div>
                                </div>

                                <div className="og-tl-item">
                                  <div className="og-tl-label">
                                    <i
                                      className="fa fa-user-check"
                                      style={{ color: "#8492a6" }}
                                    />{" "}
                                    Manager By
                                  </div>

                                  <div
                                    className="og-tl-date"
                                    style={{ color: "#8492a6" }}
                                  >
                                    {formatDate(item?.ManagerReviewDeadline)}
                                  </div>
                                </div>

                                <div className="og-tl-item">
                                  <div className="og-tl-label">
                                    <i
                                      className="fa fa-flag-checkered"
                                      style={{ color: "#8492a6" }}
                                    />{" "}
                                    Closure
                                  </div>

                                  <div
                                    className="og-tl-date"
                                    style={{ color: "#8492a6" }}
                                  >
                                    {formatDate(item?.CycleEndDate)}
                                  </div>
                                </div>
                              </div>

                              <div
                                style={{ marginTop: 10 }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <button
                                  type="button"
                                  className="btn-og btn-og-primary btn-og-sm"
                                  onClick={() => handleSelfAssessment(item)}
                                >
                                  <i className="fa fa-pen-to-square" /> Fill
                                  Self Assessment
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                style={{
                                  background: "#f8f9fb",
                                  border: "1px solid #e9ecf0",
                                  borderRadius: 10,
                                  padding: "12px 14px",
                                  marginTop: 8,
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginBottom: 6,
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "11.5px",
                                      fontWeight: 700,
                                      color: "#5f6b7c",
                                    }}
                                  >
                                    <i
                                      className="fa fa-shield-halved"
                                      style={{ color: "#EC4119" }}
                                    />{" "}
                                    Final Feedback
                                  </div>

                                  <button
                                    type="button"
                                    className="btn-og btn-og-secondary btn-og-sm"
                                    onClick={() =>
                                      toggleFeedback(item?.CycleId)
                                    }
                                  >
                                    <i className="fa fa-eye" />{" "}
                                    {showFeedback[item?.CycleId]
                                      ? "Hide"
                                      : "Show"}
                                  </button>
                                </div>

                                {!showFeedback[item?.CycleId] ? (
                                  <div
                                    className="fb-mask"
                                    style={{
                                      fontSize: 13,
                                      color: "#d1d5db",
                                      letterSpacing: 2,
                                      userSelect: "none",
                                    }}
                                  >
                                    ●●●●●● ●●● ●●●●●●●●● ●●●●● ●●●●●●●●●●● ●●●●
                                    ●●●●●●● ●●●●●●●●●.
                                  </div>
                                ) : (
                                  <div
                                    className="fb-reveal"
                                    style={{
                                      fontSize: 13,
                                      color: "#374151",
                                      lineHeight: 1.6,
                                    }}
                                  >
                                    {item?.hrFeedback ||
                                      "No HR feedback available."}
                                  </div>
                                )}

                                <div
                                  style={{
                                    fontSize: 11,
                                    color: "#b0b8c8",
                                    marginTop: 6,
                                  }}
                                >
                                  <i className="fa fa-lock" /> Confidential — do
                                  not share with colleagues.
                                </div>
                              </div>

                              <div
                                style={{
                                  marginTop: 8,
                                  fontSize: 12,
                                  color: "#8492a6",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {item?.acknowledgedDate && (
                                  <>
                                    <i
                                      className="fa fa-circle-check"
                                      style={{ color: "#48bb78" }}
                                    />{" "}
                                    Acknowledged{" "}
                                    {formatDate(item?.acknowledgedDate)}
                                    &nbsp;·&nbsp;
                                  </>
                                )}

                                <button
                                  type="button"
                                  className="link-btn"
                                  onClick={() =>
                                    handleEmployeeAppraisalView(item)
                                  }
                                >
                                  <i className="fa fa-eye" /> View Full
                                  Appraisal
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })
                  )}
                </div>

{managerReview && (
  <>
                <div className="mb-3">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <div className="og-hub-title">
                      <i className="fa fa-users" style={{ color: "#7c3aed" }} />{" "}
                      My Team's Reviews
                      <span className="og-hub-badge">
                        {teamAppraisalsCount || 0} reportees
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <select
                        className="og-select"
                        style={{
                          width: 210,
                          fontSize: 12,
                        }}
                        value={selectedCycleId}
                        onChange={handleCycleChange}
                        disabled={loadingCycles}
                      >
                        {loadingCycles ? (
                          <option value="">Loading cycles...</option>
                        ) : allCycles?.length > 0 ? (
                          allCycles.map((cycle) => (
                            <option
                              key={cycle?.Id }
                              value={
                                 cycle?.Id
                              }
                            >
                              {cycle?.Title} 
                              {/* (
                              {formatPeriod(
                                cycle?.ReviewPeriodFrom,
                                cycle?.ReviewPeriodTo,
                              )}
                              ) */}
                            </option>
                          ))
                        ) : (
                          <option value="">No cycles available</option>
                        )}
                      </select>
{teamAppraisals?.length > 0 && (
                      <button
                        type="button"
                        className="link-btn"
                        onClick={handleTeamReview}
                      >
                        View All
                        <i className="fa fa-arrow-right" />
                      </button>
                      )}
                    </div>
                  </div>

                  <div
                    className="og-card"
                    style={{
                      padding: 0,
                      overflow: "hidden",
                    }}
                  >
                    {loadingTeam ? (
                      <div
                        style={{
                          padding: 20,
                          textAlign: "center",
                          color: "#8492a6",
                        }}
                      >
                        Loading reviews...
                      </div>
                    ) : teamAppraisals?.length > 0 ? (
                      <>
                        {teamAppraisals.slice(0, 3).map((item, index) => {
                          const employeeName =
                            item?.EmployeeName ||
                            item?.FullName ||
                            item?.EmpName ||
                            "Employee";

                          const managerName =
                            item?.ManagerName || item?.ReviewerName || "";

                          const status =
                            item?.Status ||
                            item?.ReviewStatus ||
                            "Pending Review";

                          const employeeInitials =
                            item?.Initials ||
                            employeeName
                              .split(" ")
                              .map((name) => name?.[0])
                              .join("")
                              .substring(0, 2)
                              .toUpperCase();

                          const statusLower = item?.StageName?.toLowerCase();

                          const isReviewed = item?.StageId > 2;

                          const isOverdue = statusLower.includes("overdue");

                          return (
                            <div
                              className="og-letter-row"
                              key={item?.Id || item?.EmployeeId || index}
                            >
                              <div
                                className="og-emp-av"
                                style={{
                                  background:
                                    index % 2 === 0 ? "#EC4119" : "#2b6cb0",
                                  width: 30,
                                  height: 30,
                                  fontSize: 10,
                                }}
                              >
                                {employeeInitials}
                              </div>

                              <div style={{ flex: 1 }}>
                                <div
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 600,
                                  }}
                                >
                                  {employeeName}
                                </div>

                                <div
                                  style={{
                                    fontSize: 11,
                                    color: "#8492a6",
                                  }}
                                >
                                  {item?.Designation || item?.JobTitle || ""}
                                </div>
                              </div>

                              <span
                                className={`badge-og ${
                                  isReviewed
                                    ? "badge-self"
                                    : isOverdue
                                      ? "badge-overdue"
                                      : "badge-self"
                                }`}
                                style={{
                                  fontSize: 11,
                                }}
                              >
                                {status}
                              </span>

                              {item?.StageId === 1 && (
                                <button
                                  type="button"
                                  className="btn-og btn-og-secondary btn-og-sm"
                                  onClick={() => sendRemind(item)}
                                >
                                  <i className="fa fa-bell" />
                                </button>
                              )}

                              {isReviewed ? (
                                <button
                                  type="button"
                                  className="btn-og btn-og-secondary btn-og-sm"
                                  onClick={() =>
                                    teamManagersReview(item, "view")
                                  }
                                >
                                  <i className="fa fa-eye" /> View
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn-og btn-og-primary btn-og-sm"
                                  onClick={() =>
                                    teamManagersReview(item, "review")
                                  }
                                >
                                  <i className="fa fa-pen-to-square" />

                                  {isOverdue ? " Review Now" : " Review"}
                                </button>
                              )}
                            </div>
                          );
                        })}

                        {teamAppraisals?.length > 3 && (
                          <div
                            className="og-letter-row"
                            style={{
                              background: "#f8f9fb",
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                                fontSize: 12,
                                color: "#8492a6",
                                textAlign: "center",
                              }}
                            >
                              +{teamAppraisals.length - 3} more
                            </div>

                            <button
                              type="button"
                              className="btn-og btn-og-secondary btn-og-sm"
                              onClick={handleTeamReview}
                            >
                              View All
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          padding: 20,
                          textAlign: "center",
                          color: "#8492a6",
                        }}
                      >
                        No team reviews found.
                      </div>
                    )}
                  </div>
                </div>

                <div className="mb-3">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <div className="og-hub-title">
                      <i className="fa fa-users" style={{ color: "#2b6cb0" }} />{" "}
                      Skip-Level Reviews
                      <span className="og-hub-badge">
                        {skipLevelAppraisalsCount || 0} reportees
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <select
                        className="og-select"
                        style={{
                          width: 210,
                          fontSize: 12,
                        }}
                        value={selectedCycleId}
                        onChange={handleCycleChange}
                        disabled={loadingCycles}
                      >
                       
                         {loadingCycles ? (
                          <option value="">Loading cycles...</option>
                        ) : allCycles?.length > 0 ? (
                          allCycles.map((cycle) => (
                            <option
                              key={cycle?.Id}
                              value={
                                cycle?.Id
                              }
                            >
                              {cycle?.Title}
                               {/* (
                              {formatPeriod(
                                cycle?.ReviewPeriodFrom,
                                cycle?.ReviewPeriodTo,
                              )}
                              ) */}
                            </option>
                          ))
                        ) : (
                          <option value="">No cycles available</option>
                        )}
                      </select>

{skipLevelAppraisals?.length > 0 && (
                      <button
                        type="button"
                        className="link-btn"
                        onClick={handleSkipLevelReview}
                      >
                        View All
                        <i className="fa fa-arrow-right" />
                      </button>
                      )}
                    </div>
                  </div>

                  <div
                    className="og-card"
                    style={{
                      padding: 0,
                      overflow: "hidden",
                    }}
                  >
                    {loadingSkipLevel ? (
                      <div
                        style={{
                          padding: 20,
                          textAlign: "center",
                          color: "#8492a6",
                        }}
                      >
                        Loading reviews...
                      </div>
                    ) : skipLevelAppraisals?.length > 0 ? (
                      <>
                        {skipLevelAppraisals.slice(0, 3).map((item, index) => {
                          const employeeName =
                            item?.EmployeeName ||
                            item?.FullName ||
                            item?.EmpName ||
                            "Employee";

                          const managerName =
                            item?.ManagerName || item?.ReviewerName || "";

                          const status =
                            item?.Status ||
                            item?.ReviewStatus ||
                            "Pending Review";

                          const initials =
                            item?.Initials ||
                            employeeName
                              .split(" ")
                              .map((name) => name?.[0])
                              .join("")
                              .substring(0, 2)
                              .toUpperCase();

                          const statusLower = item?.StageName?.toLowerCase();

                          const isOverdue = statusLower.includes("overdue");

                          return (
                            <div
                              className="og-letter-row"
                              key={item?.Id || item?.EmployeeId || index}
                            >
                              <div
                                className="og-emp-av"
                                style={{
                                  background:
                                    index % 2 === 0 ? "#EC4119" : "#d97706",
                                  width: 30,
                                  height: 30,
                                  fontSize: 10,
                                }}
                              >
                                {initials}
                              </div>

                              <div style={{ flex: 1 }}>
                                <div
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 600,
                                  }}
                                >
                                  {employeeName}
                                </div>

                                <div
                                  style={{
                                    fontSize: 11,
                                    color: "#8492a6",
                                  }}
                                >
                                  {managerName
                                    ? `Mgr: ${managerName}`
                                    : item?.Designation || ""}
                                </div>
                              </div>

                              <span
                                className={`badge-og ${
                                  isOverdue ? "badge-overdue" : "badge-self"
                                }`}
                                style={{
                                  fontSize: 11,
                                }}
                              >
                                {status}
                              </span>

                              {item?.StageId === 1 && (
                                <button
                                  type="button"
                                  className="btn-og btn-og-secondary btn-og-sm"
                                  onClick={() => sendRemind(item)}
                                >
                                  <i className="fa fa-bell" /> 
                                </button>
                              )}

                              {item?.StageId <= 3 ? (
                                <button
                                  type="button"
                                  className="btn-og btn-og-primary btn-og-sm"
                                  style={
                                    isOverdue
                                      ? {
                                          background: "#e53e3e",
                                        }
                                      : undefined
                                  }
                                  onClick={() =>
                                    handleSkipLevelCycleReviews(item)
                                  }
                                >
                                  <i className="fa fa-pen-to-square" />

                                  {isOverdue ? " Review Now" : " Review"}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn-og btn-og-primary btn-og-sm"
                                  onClick={() =>
                                    handleSkipLevelCycleViews(item)
                                  }
                                >
                                  <i className="fa fa-eye" />
                                  View
                                </button>
                              )}
                            </div>
                          );
                        })}

                       
                      </>
                    ) : (
                      <div
                        style={{
                          padding: 20,
                          textAlign: "center",
                          color: "#8492a6",
                        }}
                      >
                        No skip-level reviews found.
                      </div>
                    )}
                  </div>
                </div>
                </>
                )}
              </div>

              <div className="right-emp-cycle mb-5">
                <div
                  className="my-goals"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 10,
                  }}
                >
                  <div className="og-hub-title">
                    <i
                      className="fa fa-bullseye"
                      style={{ color: "#EC4119" }}
                    />{" "}
                    My Goals &amp; KRAs
                    {kraList?.length > 0 && (
                      <span className="og-hub-badge">
                          {kraList.filter((el) => el.Status === "Active").length} Active
                      </span>
                    )}
                  </div>
                  {/* {kraList?.length > 0 && ( */}
                  <button
                    type="button"
                    className="link-btn"
                    onClick={handleGoals}
                  >
                    View &amp; Update <i className="fa fa-arrow-right" />
                  </button>
                  {/* )} */}
                </div>
                <div
                  className="og-card"
                  style={{ padding: 0, overflow: "hidden" }}
                >
                  {kraLoading ? (
                    <div
                      style={{
                        padding: "20px",
                        textAlign: "center",
                        color: "#8492a6",
                        fontSize: 12,
                      }}
                    >
                      Loading goals...
                    </div>
                  ) : kraList?.length > 0 ? (
                    <>
                      {kraList.map((item, index) => {
                        const progress = Number(
                          item?.CompletionPct ??
                            0,
                        );

                        const kpiCount =
                          item?.KpiCount ??
                          item?.KPICount ??
                          item?.Kpis?.length ??
                          item?.KPIs?.length ??
                          0;

                        const colors = [
                          "#EC4119",
                          "#7c3aed",
                          "#2b6cb0",
                          "#d97706",
                          "#276749",
                        ];

                        const progressColor =
                          progress >= 80
                            ? "#276749"
                            : progress >= 50
                              ? "#d97706"
                              : "#2b6cb0";

                        return (
                          <div
                            className="og-kra-mini"
                            key={item?.Id || item?.KraId || index}
                          >
                            {/* KRA Number */}
                            <div
                              style={{
                                width: 24,
                                height: 24,
                                background: colors[index % colors.length],
                                borderRadius: 50,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                fontSize: 9,
                                fontWeight: 700,
                                flexShrink: 0,
                              }}
                            >
                              K{index + 1}
                            </div>

                            {/* KRA Details */}
                            <div
                              style={{
                                flex: 1,
                                minWidth: 0,
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 12.5,
                                  fontWeight: 600,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item?.Name ||
                                  item?.KraName ||
                                  item?.KRAName ||
                                  item?.Title ||
                                  "Untitled KRA"}
                              </div>

                              <div
                                style={{
                                  fontSize: 11,
                                  color: "#8492a6",
                                }}
                              >
                                {kpiCount} {kpiCount === 1 ? "KPI" : "KPIs"}
                                {item?.DueDate
                                  ? ` · Due ${item.DueDate}`
                                  : item?.Status
                                    ? ` · ${item.Status}`
                                    : ""}
                              </div>
                            </div>

                            {/* Progress */}
                            {/* <div
                              style={{
                                textAlign: "right",
                                flexShrink: 0,
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 13,
                                  fontWeight: 700,
                                  color: progressColor,
                                }}
                              >
                                {progress}%
                              </div>

                              <div className="og-kpi-bar">
                                <div
                                  className="og-kpi-bar-fill"
                                  style={{
                                    width: `${Math.min(Math.max(progress, 0), 100)}%`,
                                    background: progressColor,
                                  }}
                                />
                              </div>
                            </div> */}
                          </div>
                        );
                      })}

                      {/* Update KPI Button */}
                      <div
                        style={{
                          padding: "10px 14px",
                          borderTop: "1px solid #f1f3f7",
                        }}
                      >
                        <button
                          type="button"
                          className="btn-og btn-og-outline btn-og-sm"
                          onClick={handleGoals}
                          style={{
                            width: "100%",
                            justifyContent: "center",
                          }}
                        >
                          <i className="fa fa-pen-to-square" /> Update KPI
                          Progress
                        </button>
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        padding: "20px",
                        textAlign: "center",
                        color: "#8492a6",
                        fontSize: 12,
                      }}
                    >
                      No goals found
                      
                    </div>
                  )}
                </div>

                {/* <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 10,
                    }}
                  >
                    <div className="og-hub-title">
                      <i
                        className="fa fa-file-lines"
                        style={{ color: "#8492a6" }}
                      />{" "}
                      Appraisal Letters
                    </div>
                  </div>
                  <div
                    className="og-card"
                    style={{ padding: 0, overflow: "hidden" }}
                  >
                    <div className="og-letter-row">
                      <div className="og-letter-icon">
                        <i
                          className="fa fa-file-pdf"
                          style={{ color: "#EC4119" }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 600 }}>
                          FY 25-26 Appraisal Letter
                        </div>
                        <div style={{ fontSize: 11, color: "#8492a6" }}>
                          Issued Mar 31 2026 · Vital
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn-og btn-og-secondary btn-og-sm"
                      >
                        <i className="fa fa-download" />
                      </button>
                    </div>
                    <div className="og-letter-row">
                      <div className="og-letter-icon">
                        <i
                          className="fa fa-file-pdf"
                          style={{ color: "#EC4119" }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 600 }}>
                          FY 24-25 Appraisal Letter
                        </div>
                        <div style={{ fontSize: 11, color: "#8492a6" }}>
                          Issued Apr 15 2025 · Adequate
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn-og btn-og-secondary btn-og-sm"
                      >
                        <i className="fa fa-download" />
                      </button>
                    </div>
                    <div
                      className="og-letter-row"
                      style={{ background: "#f8f9fb" }}
                    >
                      <div
                        style={{
                          flex: 1,
                          fontSize: 12,
                          color: "#8492a6",
                          fontStyle: "italic",
                        }}
                      >
                        FY 26-27 letter available after cycle closes.
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showAckModal && (
        <div className={`og-modal-overlay ${showAckModal ? "open" : ""}`}>
          <div
            className="og-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="og-modal-header">
              <div className="og-modal-title">
                <i
                  className="fa fa-check-circle"
                  style={{ color: "#48bb78" }}
                />{" "}
                Acknowledge Appraisal
              </div>
              <button
                type="button"
                className="og-modal-close"
                onClick={closeAckModal}
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div
                style={{
                  background: "#fffbeb",
                  border: "1px solid #fbd38d",
                  borderRadius: 8,
                  padding: 12,
                  marginBottom: 14,
                  fontSize: 13,
                  color: "#744210",
                }}
              >
                <i className="fa fa-circle-info" style={{ color: "#d97706" }} />{" "}
                Acknowledging means you have reviewed your outcome. You may
                still raise a representation to your manager.
              </div>
              <div
                style={{
                  background: "#f8f9fb",
                  borderRadius: 8,
                  padding: 12,
                  fontSize: 13,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 6,
                  }}
                >
                  <span style={{ color: "#8492a6" }}>Cycle</span>
                  <strong>FY 24-25 Annual Review</strong>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 6,
                  }}
                >
                  <span style={{ color: "#8492a6" }}>Final Score</span>
                  <strong>3.2 / 5.0</strong>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span style={{ color: "#8492a6" }}>Rating Label</span>
                  <span className="badge-og badge-adequate">Adequate</span>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-og btn-og-secondary"
                onClick={closeAckModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-og btn-og-primary"
                onClick={closeAckModal}
              >
                <i className="fa fa-check" /> I Acknowledge This Appraisal
              </button>
            </div>
          </div>
        </div>
      )}

      {showRemindnoti && selectedReminderItem && (
        <div
          className={`og-modal-overlay ${showRemindnoti ? "open" : ""}`}
          onClick={closeReminderModal}
        >
          <div
            className="og-modal"
            onClick={(event) => event.stopPropagation()}
          >
            {/* Header */}
            <div className="og-modal-header">
              <div className="og-modal-title">🔔 Send Notification</div>

              <button
                type="button"
                className="og-modal-close"
                onClick={closeReminderModal}
                disabled={sendingReminder}
              >
                <i className="fa fa-times" />
              </button>
            </div>

           <div className="modal-body">
                {/* Employee */}
            <div className="emp-target">
              <div className="avatar notification-avatar">
                {(selectedReminderItem?.EmployeeName || "Employee")
                  .split(" ")
                  .map((name) => name?.[0])
                  .join("")
                  .substring(0, 2)
                  .toUpperCase()}
              </div>

              <div>
                <div className="target-name">
                  {selectedReminderItem?.EmployeeName ||
                    selectedReminderItem?.FullName ||
                    selectedReminderItem?.EmpName ||
                    "Employee"}
                </div>

                <div className="target-meta">
                  Emp{" "}
                  {selectedReminderItem?.EmpId ||
                    selectedReminderItem?.EmployeeId ||
                    "-"}
                  {" · "}
                  {selectedReminderItem?.Designation ||
                    selectedReminderItem?.JobTitle ||
                    "-"}
                </div>

                <span className="target-stage">
                  ⚠ {selectedReminderItem?.StageName || "Self Assessment"}
                  {selectedReminderItem?.IsOverdue ? " · Overdue" : ""}
                </span>
              </div>
            </div>

            {/* Notification type */}
            <div className="opt-list">
              <div className="opt-item">
                <div className="opt-icon notification-icon-self">⏰</div>

                <div className="opt-text">
                  <div className="opt-title">Self Assessment Reminder</div>

                  <div className="opt-sub">
                    Send a reminder to{" "}
                    {selectedReminderItem?.EmployeeName || "the employee"} to
                    complete their self-assessment.
                  </div>
                </div>
              </div>
            </div>

            {/* Message */}
            <div style={{ marginTop: 14 }}>
              <label className="og-label" style={{ marginBottom: 6 }}>
                Notification Message
              </label>

              <textarea
                className="og-input"
                rows={4}
                value={reminderMessage}
                onChange={(e) => setReminderMessage(e.target.value)}
                placeholder="Enter reminder message..."
                disabled={sendingReminder}
                style={{
                  width: "100%",
                  resize: "vertical",
                }}
              />
            </div>
           </div>

            {/* Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn-og btn-og-secondary"
                onClick={closeReminderModal}
                disabled={sendingReminder}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn-og btn-og-primary"
                onClick={handleSendReminder}
                disabled={sendingReminder}
              >
                {sendingReminder ? (
                  <>
                    <i className="fa fa-spinner fa-spin" /> Sending...
                  </>
                ) : (
                  <>
                    <i className="fa fa-paper-plane" /> Send Reminder
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

    {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </>
  );
};

export default AssessmentEmployeeCycles;
